const dropdownMenu = (triggerList: HTMLButtonElement[]) => {
	type DropdownMenuState = {
		trigger: HTMLButtonElement;
		panel: HTMLElement;
	};

	const states: DropdownMenuState[] = [];
	const liElements: HTMLLIElement[] = [];

	function openPanel(state: DropdownMenuState) {
		const { trigger, panel } = state;
		trigger.setAttribute("aria-expanded", "true");
		panel.removeAttribute("inert");
		panel.hidden = false;
	}

	function closePanel(state: DropdownMenuState) {
		const { trigger, panel } = state;
		trigger.setAttribute("aria-expanded", "false");
		panel.setAttribute("inert", "");
	}

	triggerList.forEach((trigger) => {
		const li = trigger.closest("li");
		if (li) liElements.push(li);
		const panelId = trigger.getAttribute("aria-controls") || "";
		const panel = document.getElementById(panelId);
		if (!panel) return;

		const state: DropdownMenuState = { trigger, panel };
		states.push(state);

		trigger.addEventListener("click", (event) => {
			if (!(event instanceof MouseEvent) || event.button !== 0) {
				return;
			}
			event.preventDefault();

			const isOpen = trigger.getAttribute("aria-expanded") === "true";
			if (isOpen) {
				closePanel(state);
			} else {
				openPanel(state);
			}
		});
	});

	if (liElements.length > 0) {
		liElements.forEach((parent, i) => {
			const trigger = triggerList[i];
			const panelId = trigger.getAttribute("aria-controls") || "";
			const panel = document.getElementById(panelId);
			if (!panel) return;

			const state: DropdownMenuState = { trigger, panel };
			states.push(state);

			parent.addEventListener("mouseenter", () => {
				openPanel(state);
			});

			parent.addEventListener("mouseleave", () => {
				closePanel(state);
			});
		});
	}
};
export default dropdownMenu;
